/**
 * Module-level access-token holder. The auth bridge writes the current bearer here; the API client
 * (api/client.ts) reads it synchronously in its request interceptor. Kept out of React state so the
 * axios interceptor never closes over a stale render.
 */
let accessToken: string | null = null;
let onUnauthorized: (() => void) | null = null;

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function getAccessToken(): string | null {
  return accessToken;
}

/** Registered by the auth bridge; invoked by the API client on a 401 (reject-closed). */
export function setUnauthorizedHandler(fn: (() => void) | null): void {
  onUnauthorized = fn;
}

export function handleUnauthorized(): void {
  onUnauthorized?.();
}
